var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 48,
    viewBox: "0 0 139 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1288_5528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.1822 20.7613C73.1945 20.5621 73.1994 20.3629 73.1994 20.1612C73.1994 13.5458 67.8333 8.17969 61.2179 8.17969C54.6024 8.17969 49.2363 13.5458 49.2363 20.1612C49.2363 26.7767 54.6 32.1428 61.2179 32.1428C67.0144 32.1428 71.8518 28.0284 72.9609 22.5566H66.0479C65.1675 24.3322 63.3353 25.552 61.2179 25.552C58.4438 25.552 56.1567 23.4542 55.8591 20.7588H73.1822V20.7613ZM61.2154 14.7705C63.6526 14.7705 65.7159 16.3912 66.3799 18.6168H56.051C56.715 16.3936 58.7734 14.7705 61.2154 14.7705Z",
    fill: "#F96619"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.952 24.6961V8.65918H122.958V31.6607H138.456V24.6936H129.955L129.952 24.6961Z",
    fill: "#F96619"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0971 8.69336L84.8598 21.1766L80.5757 8.69336H72.9053L81.4709 31.7244H88.2511L96.6348 8.69336H89.0996H89.0971Z",
    fill: "#F96619"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.529 8.17969C101.914 8.17969 96.5479 13.5458 96.5479 20.1612C96.5479 26.7767 101.914 32.1428 108.529 32.1428C115.145 32.1428 120.511 26.7791 120.511 20.1612C120.511 13.5434 115.147 8.17969 108.529 8.17969ZM108.529 25.5544C105.554 25.5544 103.136 23.1419 103.136 20.1612C103.136 17.1806 105.551 14.7681 108.529 14.7681C111.508 14.7681 113.923 17.1831 113.923 20.1612C113.923 23.1394 111.51 25.5544 108.529 25.5544Z",
    fill: "#F96619"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6534 44.5944L50.3682 39.8702C50.3485 39.6464 50.2845 39.4373 50.1862 39.2504L33.6205 5.92488L33.6082 5.93964C32.7278 3.96485 30.844 2.54339 28.5938 2.32451C27.6199 2.23106 26.6436 2.14991 25.6673 2.08105C25.5836 0.917813 24.6147 -0.00195312 23.4293 -0.00195312H11.7527C10.5674 -0.00195312 9.5984 0.917813 9.51478 2.08105C8.54583 2.14991 7.57688 2.2286 6.60793 2.32206C3.66419 2.60487 1.34264 4.94855 1.08441 7.8923L0.0244677 25.4195C-0.0443918 26.5459 0.0293862 27.6771 0.280232 28.7764C1.26886 33.1146 4.62084 36.5526 8.9098 37.6667L43.2412 47.789C43.3863 47.8456 43.5388 47.8874 43.6937 47.9218L43.7306 47.9316C43.9421 47.9735 44.1585 47.998 44.3823 47.998H47.4441C48.9762 47.998 50.2575 46.9283 50.5846 45.497C50.651 45.1994 50.6731 44.8945 50.6534 44.592V44.5944Z",
    fill: "url(#paint0_linear_1288_5528)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.40515 24.6218C3.8263 24.6218 2.56469 23.3037 2.63355 21.7248L3.17951 9.30551C3.36149 7.38728 4.87886 5.86253 6.79955 5.67809C10.3704 5.33379 14.0027 5.15918 17.5908 5.15918C21.1789 5.15918 24.8088 5.33379 28.3796 5.67809C30.3003 5.86253 31.8201 7.38728 31.9997 9.30551L32.5456 21.7248C32.6145 23.3037 31.3529 24.6218 29.774 24.6218H5.40515Z",
    fill: "#290256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0775 4.28452C19.4156 4.02138 15.7488 4.02138 12.1042 4.2796C11.8066 4.30173 11.546 4.07794 11.5214 3.78037C11.4968 3.4828 11.723 3.22211 12.0255 3.19998C15.7218 2.93684 19.4427 2.93684 23.1537 3.20244C23.4587 3.22457 23.6849 3.48525 23.6628 3.78283C23.6382 4.0804 23.3775 4.30173 23.0775 4.28206V4.28452Z",
    fill: "#FFA51E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.504 31.924C6.47648 31.924 7.26484 31.1357 7.26484 30.1632C7.26484 29.1907 6.47648 28.4023 5.504 28.4023C4.53152 28.4023 3.74316 29.1907 3.74316 30.1632C3.74316 31.1357 4.53152 31.924 5.504 31.924Z",
    fill: "#FFA51E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6759 31.9387C30.6484 31.9387 31.4367 31.1503 31.4367 30.1778C31.4367 29.2053 30.6484 28.417 29.6759 28.417C28.7034 28.417 27.915 29.2053 27.915 30.1778C27.915 31.1503 28.7034 31.9387 29.6759 31.9387Z",
    fill: "#FFA51E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2423 23.0802C14.751 23.0802 12.7246 21.0537 12.7246 18.5625H14.7633C14.7633 19.9299 15.8749 21.0414 17.2423 21.0414C18.6096 21.0414 19.7212 19.9299 19.7212 18.5625H21.76C21.76 21.0537 19.7335 23.0802 17.2423 23.0802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4346 14.2464C9.34516 14.2464 8.44999 13.4177 8.34424 12.3553H15.8081C15.6876 10.1222 13.8382 8.35156 11.5757 8.35156C9.31319 8.35156 7.33594 10.2501 7.33594 12.5913C7.33594 14.9326 9.23449 16.8311 11.5757 16.8311C13.7817 16.8311 15.5942 15.1441 15.7934 12.9922H12.3602C12.0356 13.7324 11.2929 14.2489 10.4346 14.2489V14.2464ZM10.4346 10.0386C11.5265 10.0386 12.4242 10.8699 12.5275 11.9323H8.34178C8.44753 10.8699 9.34516 10.0386 10.4322 10.0386H10.4346Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6646 8.34961C20.3234 8.34961 18.4248 10.2482 18.4248 12.5894C18.4248 14.9306 20.3234 16.8292 22.6646 16.8292C25.0058 16.8292 26.9044 14.9306 26.9044 12.5894C26.9044 10.2482 25.0058 8.34961 22.6646 8.34961ZM21.6243 14.2469C20.4635 14.2469 19.5216 13.305 19.5216 12.1443C19.5216 10.9835 20.4635 10.0391 21.6243 10.0391C22.7851 10.0391 23.7294 10.981 23.7294 12.1443C23.7294 13.3075 22.7875 14.2469 21.6243 14.2469Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1288_5528",
    x1: 55.6334,
    y1: 34.4696,
    x2: 29.1004,
    y2: 23.9316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB35D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FA8E3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F97122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F96619"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1288_5528"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 138.457,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5102a5ce108fdd198660a446df86162c.svg";
export { ForwardRef as ReactComponent };